import { createStore } from "redux";

const initialState = {
  ready: true,
  userData: {
  userProfile: {
    firstName: "",
    lastName: "",
    email: "",
    Uid: ""
  },
  userProgress: {
    score: 0,
    stockholm: {
    }
  }}
};

const stockholmdemo = {
  loc01: {
    visited: true,
    time: {
      MindSnap: {
        status: "success",
        timestamp: "2025-04-22T12:00:00Z",
      },
      speechBubble: {
        status: "fail",
        timestamp: "2025-04-22T12:00:00Z",
      },
    },
    space: {},
  },
  loc02: {
    visited: true,
    time: {
      task1: {
        status: "fail",
        timestamp: "2025-04-22T12:00:00Z",
      },
    },
    space: {},
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {

    case "UPDATE_FROM_FIREBASE":
      return {
        ...state,
        userData: {
          ...state.userData,
          userProfile: {
            ...state.userData.userProfile,
            ...action.payload.userProfile,
          },
          userProgress: {
            ...state.userData.userProgress,
            ...action.payload.userProgress,
          },
        },
      };

    case "UPDATE_USER_PROGRESS":
      return {
        ...state,
        userData: {
          ...state.userData,
          userProgress: {
            ...action.payload,
          },
        },
      };

    case "LOGOUT":
      return {
        ...initialState, // reset state
      };
    default:
      return state;
  }
}

const store = createStore(reducer);
window.myModel = store;
export default store;

export const updateFromFirebase = (data) => ({
  type: "UPDATE_FROM_FIREBASE",
  payload: data,
});

export const updateUserProgress = (progress) => ({
  type: "UPDATE_USER_PROGRESS",
  payload: progress,
});


//remove this
export const mapStateToProps = (state) => ({
  count: state.count,
});

//remove this
export const mapDispatchToProps = (dispatch) => ({
  increment: () => dispatch({ type: "INCREMENT" }),
});


const imageModel = {
  originalImage: null,
  capturedImage: null,

  setOriginal(image) {
    this.originalImage = image;
  },

  setCaptured(image) {
    this.capturedImage = image;
  },

  getOriginal() {
    return this.originalImage;
  },

  getCaptured() {
    return this.capturedImage;
  },
};